export default {
  state: {
    sign: 0, // 登录验证
  },
  mutations: {
    updateSign(state,  [s]) {
      state.sign = s
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/sign.js